// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3TUiG","footer":"Form_footer__Wm6p5"};